import { formatRoleName } from './roleUtils';

/**
 * Display labels for a leave approval step. The API labels a role approver with the
 * role's identifier (`hr_admin`); the portal shows roles by formatRoleName everywhere
 * else, so the label is rebuilt here from the step's approvers.
 */
export const approverLabel = (approver) =>
  approver.approver_kind === 'role' ? formatRoleName(approver.label) : approver.label;

/**
 * A step's name, by the same rule as stepLabel in server/services/leaveService.js:
 * 'any' reads as alternatives, "Line manager or HR Admin"; 'all' says so outright,
 * "All of: Line manager, HR Admin" - a role there means every holder, so even a single
 * role is spelled "All of: HR Admin".
 */
export const leaveStepLabel = (step) => {
  const approvers = step.approvers || [];
  const labels = approvers.map(approverLabel).filter(Boolean);
  if (!labels.length) return step.label || '';
  const everyone = step.mode === 'all'
    && (labels.length > 1 || approvers.some((a) => a.approver_kind === 'role'));
  return everyone ? `All of: ${labels.join(', ')}` : labels.join(' or ');
};
